import { RootState } from "../reducers";
import { AclState } from "./types";

export const getAcl = ({ acl }: RootState): AclState =>
  acl || {
    loading: false,
    data: void 0,
    error: null,
  };
